import { makeStyles } from "@material-ui/core/styles";
import { AutocompleteField } from "@roc/ui";
import { observer } from "mobx-react";
import { useState } from "react";
import { useLoanVendorStore } from "../../hooks/userLoanVendorStore";

const useStyles = makeStyles((theme) => ({
  entityLabel: {
    display: "flex",
    alignItems: "center",
  },
  autoComplete: {
    minWidth: "300px",
  },
}));

export const LoanVendorSearchBar = observer(({ }) => {
  const classes = useStyles();
  const [inputValue, setInputValue] = useState("");
  const { loanVendorStore } = useLoanVendorStore();

  return (
    <>
      <AutocompleteField
        label=""
        placeHolder="Search Vendor"
        options={loanVendorStore.servicingVendors}
        value={inputValue}
        onChange={(value) => {
          setInputValue(value);
        }}
        onSelect={(option: any) => {
          setInputValue(option.label);
          loanVendorStore.setLoanVendor(option.value);
        }}
        className={classes.autoComplete}
      />
    </>
  );
});
